/* The home page animations: looping hero videos and the step 2 profile slideshow. */
(function () {
  if (window.tappdHomeVideos) return;
  window.tappdHomeVideos = true;

  function videos() {
    return document.querySelectorAll('[data-tappd-video] video');
  }

  function playVideos() {
    videos().forEach(function (v) {
      if (v.paused) v.play().catch(function () {});
    });
  }

  /* tap-to-start for phones that block autoplay lives inline with each video
     (tappd-media.liquid), so it works before this deferred script has loaded */

  /* phones pause videos in background tabs; pick them up again on return */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) playVideos();
  });

  /* step 2 slideshow: step to the next slide on a timer */
  function startSlides() {
    document.querySelectorAll('[data-tappd-slides]').forEach(function (box) {
      if (box._timer) return;
      var slides = box.children;
      if (slides.length < 2) return;
      var i = 0;
      box._timer = setInterval(function () {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }, parseInt(box.dataset.interval, 10) || 2500);
    });
  }

  function init() {
    playVideos();
    startSlides();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
